import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getTestId, isValidObject } from '@airtel/air-design-system';
import { OrderSummaryCardWidget } from '../order-summary-card-widget';
import { SectionTitleWidget } from '../section-title-widget';
import { TrackOrderStepperWidget } from '../track-order-stepper-widget';
import { LinkListItemWidget } from '../link-list-item-widget';
import { View } from 'react-native';
export var CollapsibleSummaryCardWidgetComponent = props => {
  var _props$sectionTitleWi = props.sectionTitleWidgetProps,
    sectionTitleWidgetProps = _props$sectionTitleWi === void 0 ? {} : _props$sectionTitleWi,
    _props$orderSummaryCa = props.orderSummaryCardProps,
    orderSummaryCardProps = _props$orderSummaryCa === void 0 ? {} : _props$orderSummaryCa,
    _props$trackOrderStep = props.trackOrderStepperWidget,
    trackOrderStepperWidget = _props$trackOrderStep === void 0 ? {} : _props$trackOrderStep,
    _props$showCollapsibl = props.showCollapsible,
    showCollapsible = _props$showCollapsibl === void 0 ? false : _props$showCollapsibl,
    _props$linkListItemPr = props.linkListItemProps,
    linkListItemProps = _props$linkListItemPr === void 0 ? {} : _props$linkListItemPr,
    _props$collapsiblePro = props.collapsibleProps,
    collapsibleProps = _props$collapsiblePro === void 0 ? {} : _props$collapsiblePro,
    _props$testID = props.testID,
    testID = _props$testID === void 0 ? 'CollapsibleSummaryCardWidget' : _props$testID,
    onUserAction = props.onUserAction;
  var withAccordionProps = trackOrderStepperWidget.withAccordionProps;
  var onCollapseMetaData = collapsibleProps.onCollapseMetaData,
    onExpandMetaData = collapsibleProps.onExpandMetaData;
  var onToggleHandler = isExpanded => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(isExpanded ? onExpandMetaData : onCollapseMetaData, {
      isExpanded
    });
  };
  return _jsxs(View, Object.assign({}, getTestId(testID, 'CollapsibleCardWidget'), {
    children: [_jsx(SectionTitleWidget, Object.assign({}, sectionTitleWidgetProps, {
      onUserAction: onUserAction
    })), _jsx(OrderSummaryCardWidget, Object.assign({}, orderSummaryCardProps, {
      onUserAction: onUserAction
    })), showCollapsible && isValidObject(trackOrderStepperWidget) ? _jsx(TrackOrderStepperWidget, Object.assign({}, trackOrderStepperWidget, {
      onUserAction: onUserAction,
      withAccordionProps: Object.assign(Object.assign({}, withAccordionProps), {
        onToggleHandler
      })
    })) : _jsx(LinkListItemWidget, Object.assign({}, linkListItemProps, {
      onUserAction: onUserAction
    }))]
  }));
};
CollapsibleSummaryCardWidgetComponent.genericRendererKey = 'AirCollapsibleSummaryCardWidget';